module.exports = __webpack_public_path__ + "img/claw.3f46b9bf.png";